import React, {useState} from 'react';
import {selectLang} from "../../../../store/reducers/main/main";
import {useSelector} from "react-redux";
import {Translate} from "../../../../lang/lang";
import {returnPurchaseDownloadPdfAsync} from "../../../../store/reducers/warehouse/returnPurchase";
import IconButton from "../../../IconButton";
import {Spinner} from "react-bootstrap";
import IconCloudDownload from "../../../../assets/icon/IconCloudDownload";

const ReturnPurchaseDownloadPdf = ({returnPurchaseId, number, ...props}) => {

    const [loading, setLoading] = useState(false)
    const lang = useSelector(selectLang)
    const t = Translate

    const downloadPdfReturnPurchase = () => {
        setLoading(true)
        returnPurchaseDownloadPdfAsync({returnPurchaseId})
            .then((response) => {
                const link = document.createElement("a");
                document.body.appendChild(link);

                const blobFile = new Blob([response], {type: 'application/pdf'});
                const blobUrl = window.URL.createObjectURL(blobFile);

                link.href = blobUrl;
                link.download = `${t(lang, "warehouse.item.download_excel.return_name", {number: number})}.pdf`;
                link.click();
                link.remove();
                window.URL.revokeObjectURL(blobUrl);
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <IconButton {...props} icon="file-pdf" disabled={loading} size="sm"
                    className="btn-white-davr d-flex gap-2 align-items-center" transform="shrink-3"
                    variant="falcon-primary" onClick={downloadPdfReturnPurchase}>
            {loading ? (
                <Spinner className="align-middle ms-2" size="sm" animation="border" role="switch"/>
            ) : <IconCloudDownload/>}
            <span className="d-none d-sm-inline-block">{t(lang, "warehouse.operation.item.common.download_pdf")}</span>

        </IconButton>
    );
};

export default ReturnPurchaseDownloadPdf;
